import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolders2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolders2"><Path d="M5.5 16.5V3.5H11L13.5 6H21.5V16.5H5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 6.5V19.5H18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolders2;
